export enum GatewayPagamento {
  BS2 = 'BS2',
  SANTANDER = 'SANTANDER',
}
